import { apiClient } from "../api"
import { stringifyParams } from "../utils/api"
import { DashboardParams, DTO_Dashboard, Entity_DashboardCardPos } from "./types/dashboard"

const SYSTEM_DASHBOARD = '/system/dashboard/'

export const getDashboard = (params: DashboardParams = {}): Promise<DTO_Dashboard> => {
  const ac = apiClient()
  const queryStr = stringifyParams(params)
  const promise = ac.get(`${SYSTEM_DASHBOARD}${queryStr?.length ? `?${queryStr}` : ''}`)
    .then(res => res.data)
  return promise
}

export const updateDashboard = (data: Entity_DashboardCardPos): Promise<void> => {
  const ac = apiClient()
  const promise = ac.post(`${SYSTEM_DASHBOARD}select_dashboards/`, data)
    .then(res => res.data)
  return promise
}
